<template>
	<div id="app">
		<router-view @addItem="handleAddItem" @openHours="openHours"></router-view>
		<my-footer v-if="this.$route.name !== 'Login' && this.$route.name !== 'ConfirmOrder'"></my-footer>
		<transition name="fade">
			<div class="hours-box" v-if="hours" @click="openHours">
				<ul class="hours">
					<li>
						<h3 class="subheading">Hours of Operation</h3>
					</li>
					<li>
						<h4 class="secondary-copy">Monday 5pm - 11pm</h4>
					</li>
					<li>
						<h4 class="secondary-copy">Tuesday 5 - 11pm</h4>
					</li>
					<li>
						<h4 class="secondary-copy">Wednesday 11:30am - 11pm</h4>
					</li>
					<li>
						<h4 class="secondary-copy">Thursday 11:30am - 11pm</h4>
					</li>
					<li>
						<h4 class="secondary-copy">Friday 11:30am - 12am</h4>
					</li>
					<li>
						<h4 class="secondary-copy">Saturday 2pm - 12am</h4>
					</li>
					<li>
						<h4 class="secondary-copy">Sunday 2pm - 11pm</h4>
					</li>
				</ul>
			</div>
		</transition>
	</div>
</template>

<script>
	import MyFooter from '@/components/MyFooter'
	import Menu from '@/controllers/Menu'
	export default {
		name: 'app',
		created () {
			this.loadMenuData()
		},
		data () {
			return {
				hours: false
			}
		},
		methods: {
			loadMenuData () {
				Menu.getMenu().then(response => {
					let categories = response.payload
					let newCategory
					categories.forEach((category) => {
						if (category.length !== 0) {
							if (category.name !== 'Menu' && category.categories.length > 0) {
								newCategory = {
									name: category.name,
									id: category.id,
									items: category.categories[0].items
								}
								this.$root.categories.push(newCategory)
							}
						}
					})
					localStorage.setItem('categories', newCategory)
				}).catch(reason => {
					console.log(reason)
				})
			},
			handleAddItem (item) {
				this.$emit('addItem', item)
			},
			openHours () {
				this.hours = !this.hours
			}
		},
		components: {
			MyFooter
		}
	}
</script>

<style lang='scss'>
	@import './assets/css/main';

	.hours-box {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		background: linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5));
		.hours {
			background: white;
			padding: 3%;
		}
		li {
			margin-bottom: 5%;
		}
	}


</style>



// WEBPACK FOOTER //
// src/App.vue